import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import { useIntl } from "react-intl";
import Toast from "../../helpers/Toast";


interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (motive: string) => void;
  taskTitle?: string;
  loading?: boolean;
}

const AssistanceCheckListTaskMotiveModalComponent: React.FC<Props> = ({ isOpen, onClose, onConfirm, taskTitle, loading = false }) => {
  const intl = useIntl();
  const [motive, setMotive] = useState("");

  const handleConfirm = () => {
  if (!motive.trim()) {
    Toast.Show("error", "Motivo inválido. Por favor, preencha o motivo.");
    return;
  }
  onConfirm(motive);
};

  useEffect(() => {
    if (isOpen) setMotive("");
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md">
      <ModalHeader toggle={onClose}>
        {intl.formatMessage({ id: "Screens.AssistanceCheckList.ErrorModal.Title", defaultMessage: "Erro ao realizar a tarefa" })}
      </ModalHeader>

      <ModalBody>
        <InputComponent
          xl={12} lg={12} md={12} sm={12} xs={12}
          type="text"
          value={taskTitle ?? ""}
          label={intl.formatMessage({ id: "Screens.AssistanceCheckList.TaskTitle", defaultMessage: "Tarefa" })}
          readOnly
        />

        <InputComponent
          xl={12} lg={12} md={12} sm={12} xs={12}
          type="textArea"
          value={motive}
          label={intl.formatMessage({ id: "Screens.AssistanceCheckList.ErrorModal.MotiveLabel", defaultMessage: "Por favor apresente o motivo da falha" })}
          onChange={setMotive}
          readOnly={false}
        />
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          {intl.formatMessage({ id: "Common.Buttons.Cancel" })}
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={loading}>
          {loading ? <Spinner size="sm" /> : intl.formatMessage({ id: "Common.Buttons.Save" })}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssistanceCheckListTaskMotiveModalComponent;
